import React from "react";
import { HeaderComponent } from "./HeaderComponent";
import { FooterComponent } from "./FooterComponent";
import "../styles/home.css";
import { SectionComponent } from "./SectionComponent";
import { CardBrandComponent } from "./CardBrandComponent";
import benefits from "../data/benefits.json";
import Bimbo from "../images/Bimbo.svg";
import Coderhouse from "../images/Coderhouse.svg";
import LuigiBosca from "../images/Luigi_Bosca.svg";
import On_Fit from "../images/On_Fit.svg";
import Samsung from "../images/Samsung.svg";
import UAI from "../images/UAI.svg";
import UB from "../images/UB.svg";
import UCES from "../images/UCES.svg";
import Unilver from "../images/Unilever.svg";
import US21 from "../images/US21.svg";
import BGH from "../images/BGH.svg";
import MOLINOS from "../images/MOLINOS.png";
import MOLINOSTITLE from "../images/tienda-molinos.png";
import MOLINOSBODY from "../images/contenido-molinos.png";

const logoMap = {
  Bimbo,
  Coderhouse,
  LuigiBosca,
  On_Fit,
  Samsung,
  UAI,
  UB,
  UCES,
  Unilver,
  US21,
  BGH,
  MOLINOS,
  MOLINOSTITLE,
  MOLINOSBODY
};

export const HomeComponent = () => {
  return (
    <>
      <div className="contain-app">
        <HeaderComponent />
        <SectionComponent />
        <div className="container-cards-home">
          <div className="d-flex align-items-center justify-content-center flex-wrap container-cards">
            {benefits.map((item, index) => (
              <CardBrandComponent
                key={index}
                link={item.link}
                logo={logoMap[item.logo]}
                imgTitle={logoMap[item.imgTitle]}
                imgContenido={logoMap[item.imgContenido]}
                isBimbo={item.isBimbo}
                body={
                  <>
                    {item.body.map((section, idx) => (
                      <div className="divider-body" key={idx}>
                        {section.title && <p className="title-body-benefits">{section.title}</p>}
                        <p className="text-body" dangerouslySetInnerHTML={{ __html: section.text }} />
                      </div>
                    ))}
                  </>
                }
                footer={<>
                  {item?.footer?.map((section, idx) => (
                    <div className="divider-body" key={idx}>
                      <p className="text-body pt-4 mt-4" dangerouslySetInnerHTML={{ __html: section.text }} />
                    </div>
                  ))}
                </>}
              />
            ))}
          </div>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};